// extracted by mini-css-extract-plugin
export default {"tabContent":"TabContentTemplate_tabContent__tpETZ","padBottom0":"TabContentTemplate_padBottom0__0m5vw"};